module.exports = __webpack_public_path__ + "img/Weapon_246.cb03cede.png";